var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReOpenVerification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.2,9.6c0.2,0,0.4-0.2,0.4-0.4V5c0-0.2-0.2-0.4-0.4-0.4C7,4.5,6.8,4.7,6.8,5v4.2C6.8,9.4,7,9.6,7.2,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1,11.4c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.2-0.1-0.3c0,0-0.1-0.1-0.1-0.1c-0.2-0.1-0.4,0-0.5,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2c0,0.1,0,0.2,0.1,0.3 C7,11.4,7,11.4,7.1,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9,9.3l-1.5-1.5c-0.2-0.2-0.4-0.2-0.6,0L12,9.3c-0.2,0.2-0.2,0.4,0,0.6c0.1,0.1,0.2,0.1,0.3,0.1 c0.1,0,0.2,0,0.3-0.1l0.9-0.8c-0.2,1.3-0.8,2.4-1.7,3.3c-1.2,1.2-2.8,1.9-4.5,1.9c-3.5,0-6.3-2.8-6.3-6.3c0-1.7,0.7-3.3,1.9-4.5 c1.2-1.2,2.8-1.9,4.5-1.9c1.6,0,3.1,0.6,4.2,1.6c0.2,0.2,0.5,0.1,0.6,0c0.2-0.2,0.1-0.5,0-0.6c-1.3-1.2-3-1.8-4.8-1.8 c-1.9,0-3.7,0.8-5.1,2.1C0.8,4.3,0,6.1,0,8c0,4,3.2,7.2,7.2,7.2c1.9,0,3.7-0.8,5.1-2.1c1.1-1.1,1.8-2.5,2-4.1l0.9,0.9 c0.2,0.2,0.4,0.2,0.6,0C16,9.7,16,9.5,15.9,9.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReOpenVerification);
export default __webpack_public_path__ + "static/media/re-open-verification.0961fb7d0181b196cc25b9d4c4eafb8c.svg";
export { ForwardRef as ReactComponent };